import { mapExtraField } from './ExtraField'
import { TAbstractCatalogConfig } from './AbstractCatalogConfig'

export const entityTypes = ['taxonomy', 'resource', 'business', 'appointment'] as const
export type TEntityType = ValueOf<typeof entityTypes>

export interface TDynamicCatalogConfig extends TAbstractCatalogConfig {
  entityList: TEntityType[]
  saveToEntity: boolean
}

export const create = (data?: any): TDynamicCatalogConfig => ({
  id: '',
  name: '',
  extraId: '',
  businessIdList: [],
  networkIdList: [],
  acl: [],
  entityList: [],
  saveToEntity: false,
  ...data,
  fields: (data?.fields || []).map(mapExtraField),
  active: data?.active === 'true' || data?.active === true,
})
